import { CUSTOM_FIELD_AVAILABLE_FROM, CUSTOM_FIELD_TYPE } from "../../../utils/customField"

export namespace EXTERNAL_FORMS_HIDDEN_OPTIONS {
    export const ID = "ID"
    export const OWNER = "Owner"
    export const CREATED_DATE = "Created Date"
    export const UPDATED_DATE = "Updated Date"
    export const SUBMISSION_TIME = "Submission Time"
}

export const EXTERNAL_FORM_EXCLUDED_FIELDS = [
    EXTERNAL_FORMS_HIDDEN_OPTIONS.CREATED_DATE, 
    EXTERNAL_FORMS_HIDDEN_OPTIONS.ID,
    EXTERNAL_FORMS_HIDDEN_OPTIONS.OWNER,
    EXTERNAL_FORMS_HIDDEN_OPTIONS.SUBMISSION_TIME,
    EXTERNAL_FORMS_HIDDEN_OPTIONS.UPDATED_DATE
]

export const SUPPORTED_CUSTOM_FIELD_OBJECTS = [
    CUSTOM_FIELD_AVAILABLE_FROM.QUOTE, 
    CUSTOM_FIELD_AVAILABLE_FROM.PERSON
]

export const SUPPORTED_CUSTOM_FIELD_TYPES = [
    CUSTOM_FIELD_TYPE.TEXT,
    CUSTOM_FIELD_TYPE.DATE,
    CUSTOM_FIELD_TYPE.MULTI_LINE_TEXT,
]


// WEBPACK FOOTER //
// ./src/state/integration/wix/constants.ts